export default __webpack_public_path__ + "static/media/no-mistakes-illustration-blob-bottom.8f56ee7b.svg";